(ns app.survey.login.no-process.state)

(def states
  [::none
   ::auth-ok
   ::checking-email
   ::submitting-email-token
   ::no-phone-registered
   ::verify-phone-number
   ::sent-email-token
   ::sent-sms-token])
